var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.4075 35.3174L28.5547 7.23897C28.1157 6.41193 27.4598 5.72001 26.6574 5.23748C25.855 4.75494 24.9363 4.5 24 4.5C23.0637 4.5 22.145 4.75494 21.3426 5.23748C20.5402 5.72001 19.8843 6.41193 19.4453 7.23897L4.59248 35.3174C4.1794 36.1009 3.97607 36.9779 4.00224 37.8632C4.02842 38.7485 4.28321 39.612 4.74185 40.3697C5.20049 41.1274 5.84738 41.7535 6.61962 42.1872C7.39185 42.6209 8.26317 42.8474 9.14885 42.8447H38.8511C39.7368 42.8474 40.6081 42.6209 41.3804 42.1872C42.1526 41.7535 42.7995 41.1274 43.2581 40.3697C43.7168 39.612 43.9716 38.7485 43.9978 37.8632C44.0239 36.9779 43.8206 36.1009 43.4075 35.3174ZM24 37.8432C23.5054 37.8432 23.0219 37.6965 22.6107 37.4217C22.1994 37.147 21.8789 36.7564 21.6896 36.2994C21.5003 35.8425 21.4508 35.3397 21.5473 34.8546C21.6438 34.3695 21.882 33.9239 22.2317 33.5741C22.5814 33.2244 23.027 32.9862 23.5121 32.8897C23.9972 32.7933 24.5 32.8428 24.957 33.0321C25.4139 33.2213 25.8045 33.5419 26.0793 33.9531C26.3541 34.3643 26.5008 34.8478 26.5008 35.3424C26.5008 36.0057 26.2373 36.6418 25.7683 37.1107C25.2993 37.5797 24.6632 37.8432 24 37.8432ZM25.6672 29.5074H22.3328L21.4992 16.17H26.5008L25.6672 29.5074Z",
    fill: "#FFA722"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.832e6faa9ab9cd4249db253c99b2e3a6.svg";
export { ForwardRef as ReactComponent };